export default function LibraryProject() {
  return (
    <>
      <div class="row_binary">
        <div class="column_binary">
          <div class="container_float">
            <h2>Cash management software :</h2>
            <br />
            <p className="binary_content">
              {" "}
              The goal of this project is to create the sql database of a
              library.
              <br />
              <br />
              This project has been done using postgresql and it has been done
              from scratch step by step.
            </p>
          </div>
        </div>
        <div class="column_binary">
          <div class="container_float">
            <h2>Links :</h2>
            <br />
            <h3>
              Project repository :{" "}
              <a href="https://github.com/Viktor-hash/Library_project">
                Project repository
              </a>
            </h3>
          </div>
        </div>
      </div>
      <div class="footer_projects">
        <p>© Victor Perrault 2023. Currently in Hong Kong</p>
      </div>
    </>
  );
}
